import script from "./QuestionSubmitView.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionSubmitView.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionSubmitView.vue?vue&type=style&index=0&id=1e340da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e340da8"]])

export default __exports__